export default __webpack_public_path__ + "static/media/search.61400de2.svg";